import React from "react";
import ConfigurationSettingsCard from "../helpers/ConfigurationSettingsCard";
import { CONFIGURATION_INTEGRATIONS_PATH } from "../../../../../router/RouterUtils";
import useCustomizationContext from "../context/useCustomizationContext";
import { MergeLinkCustomizationStatus } from "../context/CustomizationContext";
import { Button, ButtonVariant, Toggle } from "@merge-api/merge-javascript-shared";
import { ExternalLink } from "lucide-react";

const ConfigurationNewIntegrationsCard = () => {
  const { organizationCustomization, setOrganizationCustomization } = useCustomizationContext();
  const autoEnableNewIntegrations =
    organizationCustomization?.auto_enable_new_integrations ?? false;

  const updateAutoEnableNewIntegrations = (newValue: boolean) => {
    // either create new org customization value or update existing one
    if (organizationCustomization != undefined) {
      const newOrgCustomization = { ...organizationCustomization };
      newOrgCustomization.auto_enable_new_integrations = newValue;
      setOrganizationCustomization(newOrgCustomization);
    } else {
      const currentOrganizationCustomization = {
        status: "PUBLISHED" as MergeLinkCustomizationStatus,
        auto_enable_new_integrations: newValue,
      };
      setOrganizationCustomization(currentOrganizationCustomization);
    }
  };

  return (
    <ConfigurationSettingsCard
      title="Enable new integrations by default"
      rightHandContent={
        <Button
          onClick={() => window.open(CONFIGURATION_INTEGRATIONS_PATH, "_blank")}
          rightIcon={<ExternalLink size={12} />}
          variant={ButtonVariant.TextBlue}
          size="sm"
        >
          View integrations
        </Button>
      }
    >
      <div className="flex flex-row justify-between">
        <p className="mb-0">When Merge releases new integrations, add them automatically to Link</p>
        <Toggle
          checked={autoEnableNewIntegrations}
          label={autoEnableNewIntegrations ? "Enabled" : "Disabled"}
          onChange={() => updateAutoEnableNewIntegrations(!autoEnableNewIntegrations)}
        />
      </div>
    </ConfigurationSettingsCard>
  );
};

export default ConfigurationNewIntegrationsCard;
